(() => {
  if (window.hcAnimeSpecsBound) return;
  window.hcAnimeSpecsBound = true;
  document.addEventListener('product:variant-change', event => {
    if (String(event.detail?.productId) !== '8235881791688') return;
    const parts = String(event.detail.variantTitle || '').split(' + ');
    if (parts.length !== 2) return;
    ['cpu', 'gpu'].forEach((field, i) => {
      document.querySelectorAll('[data-hc-anime-field="' + field + '"]').forEach(node => {
        node.textContent = parts[i];
        const link = node.closest('a');
        if (!link) return;
        const match = parts[i].match(field === 'cpu' ? /Ryzen (\d)/ : /RTX (\d+)/);
        if (match) link.href = '/collections/' + (field === 'cpu' ? 'amd-ryzen-' + match[1] : 'nvidia-rtx-' + match[1]) + '-gaming-pc';
      });
    });

    document.querySelectorAll('.product-card--label-container[data-hc-product-id="8235881791688"]').forEach(container => {
      const labels = container.querySelectorAll('.product-card--label');
      if (labels[0]) labels[0].textContent = parts[0];
      if (labels[1]) labels[1].textContent = 'NVIDIA GeForce ' + parts[1];
    });
  });
})();
